import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { RouteConfig } from 'vue-router';
import { asyncRoutes, constantRoutes, notFoundRoute } from '@/router/index';

const hasPermission = (permissions: string[], route: RouteConfig) => {
  if (route.meta && route.meta.permissions) {
    return permissions.some((permission) => route.meta!.permissions.includes(permission));
  } else {
    return true;
  }
};
const filterAsyncRoutes = (routes: RouteConfig[], permissions: string[]) => {
  const res: RouteConfig[] = [];
  routes.forEach((route) => {
    const r = { ...route };
    if (hasPermission(permissions, r)) {
      if (r.children) {
        r.children = filterAsyncRoutes(r.children, permissions);
      }
      res.push(r);
    }
  });
  return res;
};

export interface IPermissionState {
  routes: RouteConfig[];
  dynamicRoutes: RouteConfig[];
}
@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = [];
  public dynamicRoutes: RouteConfig[] = [];
  @Action
  public GenerateRoutes(permissions: string[]) {
    const accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions);
    this.SET_ROUTES(accessedRoutes);
  }
  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    this.routes = constantRoutes.concat(routes);
    this.dynamicRoutes = routes;
    this.dynamicRoutes.push(notFoundRoute); // notFoundRoute 需要放在最后
  }
}
export const PermissionModule = getModule(Permission);
